import { asArray, itExists } from '../../../../../utils';
import { getCoordsFromLocationId } from '../../../../../requests/locationsRequest';

const defaultSuggestions = {names: [], locationIds: []};

const locationTranslations = (t, messages, radiusOptions) => {
  const translations = {
    any: t(messages.radius.any),
    all: t(messages.all),
    location: t(messages.location),
    radius: t(messages.byRadius),
    locationCurrrent: t(messages.radius.locationCurrent),
    notFound: t(messages.radius.errorNotFound),
    locationPlaceholder: t(messages.radius.locationPlaceholder),
    locationDisabled: t(messages.radius.errorLocationDisabled),
    myLocation: t(messages.radius.myLocation),
    pleaseSelect: t(messages.radius.pleaseSelect)
  };

  const radiuses = asArray(radiusOptions).map((item) =>
    item.label === translations.all ? translations.any : item.label
  );
  const myLocation = { name: translations.myLocation, id: null };
  return { translations, radiuses, myLocation };
};

const getLocationTextField = () => document.querySelector('.location-filter input.typeahead-search__input');

const fromBrowserLocation = (location) => {
  if (!location) {
    return null;
  }
  if (itExists(location.latitude) && itExists(location.longitude)) {
    return {
      lat: location.latitude,
      lon: location.longitude,
    };
  }
  return null;
};

const validCoordinates = (coordinates) => itExists(coordinates?.lat) && itExists(coordinates?.lon);

const getDefaultRadiusText = (isFilterLocationSelected, translations, radiusTxt, radiuses) => {
  if (radiusTxt && radiuses.length) {
    return radiuses.find(radius => radius.match(radiusTxt));
  }
  return isFilterLocationSelected ? translations.pleaseSelect : translations.any;
};


const fetchAndDetermineLocationText = async (urlPlaceId, radiusOrLatLon, context, myLocationName, suggestedLocations, locale = 'en', isFilterLocationSelected = false) => {
  if (isFilterLocationSelected) {
    return '';
  }
  if (urlPlaceId) {
    let foundName = null;
      const locationData = await getCoordsFromLocationId(urlPlaceId, context, locale);
      if (!locationData.error && locationData.location?.name) {
        foundName = locationData.location.name;
      }

    if (!foundName) {
      const suggestionMatch = suggestedLocations?.locationIds?.find(loc => loc.id === urlPlaceId);
      if (suggestionMatch?.name) {
        foundName = suggestionMatch.name;
      }
    }
    return foundName || '';
  } else if (radiusOrLatLon) {
    return myLocationName;
  }
  return '';
};
const updateDisplayValues = (locationText, urlPlaceId, urlRadius, radiusOptions, isFilterLocationSelected, translations, radiuses, locationRef) => {
  locationRef?.current?.setTypeaheadSearch(locationText);

  const urlRadiusValue = urlRadius || '0';
  const targetRadiusIndex = radiusOptions.findIndex(opt => opt.value === urlRadiusValue);
  const effectiveRadiusIndex = targetRadiusIndex !== -1 ? targetRadiusIndex : 0;
  const effectiveUrlRadiusForText = urlPlaceId
    ? (urlRadiusValue === '0' ? '' : urlRadiusValue)
    : locationText && urlRadius && urlRadiusValue !== '0' // Check urlRadius here as it represents existence of a selected radius
      ? urlRadiusValue
      : '';
  const radiusDisplayText = getDefaultRadiusText(isFilterLocationSelected, translations, effectiveUrlRadiusForText, radiuses);
  locationRef?.current?.setRadius(radiusDisplayText);

  return effectiveRadiusIndex;
};

const getPlaceIdToUse = (locationRef, suggestedLocations, urlPlaceId) => {
  const currentSearchText = locationRef?.current?.getTypeaheadSearch();
  const selectedLocation = suggestedLocations?.locationIds?.find(
    (item) => item?.name === currentSearchText
  );
  const typeaheadPlaceId = selectedLocation?.id;
  return typeaheadPlaceId || urlPlaceId;
};

export {
  locationTranslations,
  defaultSuggestions,
  getLocationTextField,
  fromBrowserLocation,
  validCoordinates,
  getDefaultRadiusText,
  updateDisplayValues,
  fetchAndDetermineLocationText,
  getPlaceIdToUse
};
